module.exports = __webpack_public_path__ + "img/front_P2.9fae8e28.png";